export const LINKS = {
  HOME: process.env.REACT_APP_MAIN_APP,
  LOGIN: process.env.REACT_APP_MAIN_APP,
};
